import { render } from "./MainReportDGII.vue?vue&type=template&id=0b44e514&scoped=true"
import script from "./MainReportDGII.vue?vue&type=script&lang=js"
export * from "./MainReportDGII.vue?vue&type=script&lang=js"

import "./MainReportDGII.vue?vue&type=style&index=0&id=0b44e514&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b44e514"]])

export default __exports__